import { Table } from "@mantine/core";
import { CustomNumberInput } from "pages/admin/components/CustomNumberInput2";
import { FormTableLayout } from "pages/admin/components/FormatTableLayout";
import React from "react";
import { DebtorManagementChildFormProps } from "types/interface.types";

export const SalesSummaryCard: React.FC<DebtorManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const { values, setFieldValue } = formApi;

  return (
    <div className="card-container ">
      <FormTableLayout>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="Sales (MTD)"
                value={values.salesMtd}
                onChange={(v) => setFieldValue("salesMtd", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="Sales (YTD)"
                value={values.salesYtd}
                onChange={(v) => setFieldValue("salesYtd", v)}
              />
            </Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="Cash (MTD)"
                value={values.cashMtd}
                onChange={(v) => setFieldValue("cashMtd", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="Cash (YTD)"
                value={values.cashYtd}
                onChange={(v) => setFieldValue("cashYtd", v)}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="GST (MTD)"
                value={values.gstMtd}
                onChange={(v) => setFieldValue("gstMtd", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="GST (YTD)"
                value={values.gstYtd}
                onChange={(v) => setFieldValue("gstYtd", v)}
              />
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </FormTableLayout>
    </div>
  );
};
export default React.memo(SalesSummaryCard);
